import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {

  transform(items: any[], sortBy: string): any {
    return _.sortBy(items, sortBy);
}

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/sort-by.pipe.ts